import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import {
  STATIC_EXTERNAL_FEEDS,
  type ExternalFeedDef,
} from 'components/MapPage/CorporateViewTabs/EventsTab/externalFeeds';

export const EXTERNAL_FEED_CATALOG_KEY = ['external-feed-catalog'];

export async function fetchExternalFeedCatalog(): Promise<ExternalFeedDef[]> {
  const resp = await axios.get<{ data: ExternalFeedDef[] }>(
    config.apiGateway.external_feeds
  );
  return Array.isArray(resp.data?.data) && resp.data.data.length > 0
    ? resp.data.data
    : STATIC_EXTERNAL_FEEDS;
}

/** Non-ArcGIS feeds COMS can read, with field schemas per unit system. */
export function useExternalFeedCatalog() {
  return useQuery({
    queryKey: EXTERNAL_FEED_CATALOG_KEY,
    queryFn: fetchExternalFeedCatalog,
    initialData: STATIC_EXTERNAL_FEEDS,
    initialDataUpdatedAt: 0,
    staleTime: 60 * 60 * 1000,
  });
}
